window.addEventListener("load", async () => {

    var loader = document.getElementsByClassName("custom-loader");
    loader[0].classList.add("hidden");

    window.renderBlogLandingPage("#blog-react-container", loader[0].getAttribute("data-url"));
});
